(function() {
  if (window.__artrisoGiftSyncInit) return;
  window.__artrisoGiftSyncInit = true;

  var GIFT1_VARIANT = 51806477189336; // Decal Sticker Set  — unlocks at M2 (₹3,999)
  var GIFT2_VARIANT = 51806477222104; // Mother of Pearl Tile Set — unlocks at M3 (₹5,499)
  var M2_THRESHOLD  = 399900;
  var M3_THRESHOLD  = 549900;
  var syncing = false;
  var lastTotal = -1;
  var syncQueue = [];

  // Capture the real fetch before any theme script wraps it
  var _fetch = window.fetch;

  function getCart() {
    return _fetch.call(window, '/cart.js').then(function(r) { return r.json(); });
  }

  // Set exact quantities for existing line items (variant-ID based — never stale)
  function cartUpdate(updates) {
    return _fetch.call(window, '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  // Add a brand-new gift line item (always lands at end of cart)
  function addGift(variantId) {
    return _fetch.call(window, '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents();
  }

  function runSync() {
    return getCart().then(function(cart) {
      lastTotal = cart.total_price;
      var total = cart.total_price;
      var want1 = total >= M2_THRESHOLD;
      var want2 = total >= M3_THRESHOLD;

      var g1 = null, g2 = null;
      cart.items.forEach(function(item) {
        if (item.variant_id == GIFT1_VARIANT && !g1) g1 = item;
        if (item.variant_id == GIFT2_VARIANT && !g2) g2 = item;
      });
      var hasG1 = !!g1, hasG2 = !!g2;

      // Check if any gift appears before a non-gift item
      var giftSeen = false, outOfOrder = false;
      for (var i = 0; i < cart.items.length; i++) {
        var isGift = cart.items[i].variant_id == GIFT1_VARIANT ||
                     cart.items[i].variant_id == GIFT2_VARIANT;
        if (isGift) { giftSeen = true; }
        else if (giftSeen) { outOfOrder = true; break; }
      }

      // Decide what needs to happen for each gift
      //   remove via cartUpdate (variant-ID based → never a stale-key issue)
      //   add via addGift only when the item is genuinely absent
      var updates = {};
      var addG1 = false, addG2 = false;

      if (hasG1) {
        if (!want1 || outOfOrder) {
          updates[GIFT1_VARIANT] = 0;           // remove: not eligible or wrong position
          if (want1) addG1 = true;              // will re-add at end for correct position
        } else if (g1.quantity !== 1) {
          updates[GIFT1_VARIANT] = 1;           // fix quantity to exactly 1
        }
      } else if (want1) {
        addG1 = true;                           // not in cart yet, needs adding
      }

      if (hasG2) {
        if (!want2 || outOfOrder) {
          updates[GIFT2_VARIANT] = 0;
          if (want2) addG2 = true;
        } else if (g2.quantity !== 1) {
          updates[GIFT2_VARIANT] = 1;
        }
      } else if (want2) {
        addG2 = true;
      }

      var hasUpdates = Object.keys(updates).length > 0;
      if (!hasUpdates && !addG1 && !addG2) return; // nothing to do

      var chain = Promise.resolve();

      // Step 1: update quantities / remove ineligible gifts
      if (hasUpdates) {
        chain = chain.then(function() { return cartUpdate(updates); });
      }

      // Step 2: add eligible gifts that weren't present (or were just removed for reorder)
      if (addG1) { chain = chain.then(function() { return addGift(GIFT1_VARIANT); }); }
      if (addG2) { chain = chain.then(function() { return addGift(GIFT2_VARIANT); }); }

      return chain.then(refreshCart);
    }).catch(function(e) { console.error('[Artriso gifts]', e); });
  }

  function syncGifts() {
    if (syncing) {
      return new Promise(function(resolve) { syncQueue.push(resolve); });
    }
    syncing = true;
    return runSync().then(function() {
      if (syncQueue.length > 0) {
        // Requests came in while we were syncing — run one final pass
        return runSync().then(function() {
          syncing = false;
          syncQueue.splice(0).forEach(function(cb) { cb(); });
        });
      }
      syncing = false;
    }).catch(function() {
      syncing = false;
      syncQueue.splice(0).forEach(function(cb) { cb(); });
    });
  }

  // Sync on page load to correct any stale state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { syncGifts(); });
  } else {
    syncGifts();
  }

  // Intercept theme fetch calls — sync after any cart mutation
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var p = _fetch.apply(window, args);
    if (/\/cart\/(add|change|update|clear)\.js/.test(url) && !syncing) {
      p.then(function() { syncGifts(); }).catch(function() {});
    }
    return p;
  };

  // Polling fallback — catches mutations that bypass the fetch interceptor
  setInterval(function() {
    if (syncing || document.hidden) return;
    getCart().then(function(cart) {
      if (cart.total_price !== lastTotal) syncGifts();
    }).catch(function() {});
  }, 2000);

  // Pre-checkout sync: ensure correct gift state before reaching payment page
  var checkoutPending = false;

  // Only intercept clicks on the actual checkout button itself.
  // Avoids accidentally catching qty +/- submits on the shared cart-form.
  document.addEventListener('click', function(e) {
    if (checkoutPending) return;
    var el = e.target;
    while (el && el.tagName) {
      // Checkout button (Horizon: <button name="checkout"> form="cart-form")
      if (el.tagName === 'BUTTON' && el.getAttribute('name') === 'checkout') {
        e.preventDefault();
        e.stopImmediatePropagation();
        checkoutPending = true;
        // Navigate directly — works on both desktop cart page and mobile drawer
        // (where the form with id="cart-form" may not be in the same DOM scope)
        syncGifts().then(function() {
          checkoutPending = false;
          window.location.href = '/checkout';
        }).catch(function() {
          checkoutPending = false;
          window.location.href = '/checkout';
        });
        return;
      }
      // Direct checkout links (<a href="/checkout...">)
      if (el.tagName === 'A') {
        var href = el.getAttribute('href') || '';
        if (/^\/checkout(\/|$|\?)/.test(href) || /\/checkouts\//.test(href)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          checkoutPending = true;
          var dest = el.href;
          syncGifts().then(function() {
            checkoutPending = false;
            window.location.href = dest;
          });
          return;
        }
      }
      el = el.parentElement;
    }
  }, true);
})();
